import React from "react";
import { useLang } from "@/context/LanguageContext";
import { CheckCircle2, Instagram, Facebook } from "lucide-react";

const IMG = "https://customer-assets-0z36b82j.emergentagent.net/job_fea37d4b-bffe-409a-b844-1d302e7da01c/artifacts/lqpednhz_Moving_truck_advertisement_neigh%E2%80%A6_2K_202607091053.webp";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="py-24 md:py-32 bg-card/40 border-y border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="rounded-2xl overflow-hidden border border-border relative aspect-[4/5]">
          <img src={IMG} alt="Flores team" className="w-full h-full object-cover" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-bold">02 / About</div>
          <h2 className="mt-4 text-4xl md:text-5xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>
            {t.about.title}
          </h2>
          <p className="mt-6 text-muted-foreground text-lg leading-relaxed" data-testid="about-body">
            {t.about.body}
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            {t.about.badges.map((b) => (
              <div key={b} className="flex items-center gap-2 rounded-lg border border-border bg-background/60 px-4 py-3 text-sm">
                <CheckCircle2 className="h-4 w-4 text-primary" /> {b}
              </div>
            ))}
          </div>

          <div className="mt-8 flex items-center gap-4">
            <a
              href="https://www.instagram.com/floresonthemove/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-border hover:border-primary hover:text-primary px-4 py-2 text-sm transition-colors"
              data-testid="social-instagram"
            >
              <Instagram className="h-4 w-4" /> @floresonthemove
            </a>
            <a
              href="https://facebook.com/FloresOnTheMoveUS"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-border hover:border-primary hover:text-primary px-4 py-2 text-sm transition-colors"
              data-testid="social-facebook"
            >
              <Facebook className="h-4 w-4" /> Facebook
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
